import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { DarkModeService } from './services/dark-mode.service';
import { ToastContainerComponent } from './toast-container/toast-container.component';


@Component({
    selector: 'fgai-root',
    standalone: true,
    imports: [
        RouterOutlet,
        MenuComponent,
        FooterComponent, ToastContainerComponent

    ],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    title = 'Functioneringsgesprek voor AI';

    constructor(@Inject(DOCUMENT) private document: Document, private darkModeService: DarkModeService) {
        const style = this.document.createElement('link');
        style.rel = 'stylesheet';
        this.document.head.append(style);

        this.darkModeService.theme$.subscribe(theme => {
            this.document.documentElement.setAttribute('data-bs-theme', theme);
            style.href = `${theme}.css`;
        });
    }

}
